import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

interface StyleParams {
  isCollapsed: boolean;
}

const getTrailingSpacing = (theme: Theme, isCollapsed: boolean) =>
  isCollapsed
    ? { maxWidth: 0, marginLeft: 0, paddingRight: 0 }
    : { maxWidth: 200, marginLeft: theme.spacing(1), paddingRight: '1px' };

export const useSidebarNavItemStyles = makeStyles<StyleParams>()((theme, { isCollapsed }) => ({
  button: {
    width: isCollapsed ? '28px' : '100%',
    flexGrow: 0,
    minHeight: theme.spacing(2.5),
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
    color: theme.palette.text.secondary,
    transition: theme.transitions.create(['width'], {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.sharp,
    }),
    '&:hover': {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.custom.layout.shell.buttonHover,
    },
    '&.Mui-selected': {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.custom.layout.shell.buttonSelected,
      '&:hover': {
        backgroundColor: theme.palette.custom.layout.shell.buttonSelected,
      },
      '& .MuiListItemText-primary': {
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
  },
  icon: {
    color: 'inherit',
    marginRight: isCollapsed ? 0 : theme.spacing(1),
    transition: theme.transitions.create('margin-right', {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.sharp,
    }),
  },
  text: {
    opacity: isCollapsed ? 0 : 1,
    maxWidth: isCollapsed ? 0 : 200,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    transition: theme.transitions.create(['opacity', 'max-width'], {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.sharp,
    }),
    '& .MuiListItemText-primary': {
      color: 'inherit',
    },
  },
  trailing: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    overflow: 'hidden',
    ...getTrailingSpacing(theme, isCollapsed),
    opacity: isCollapsed ? 0 : 1,
    visibility: isCollapsed ? 'hidden' : 'visible',
    transition: theme.transitions.create(
      ['opacity', 'visibility', 'margin-left', 'padding-right', 'max-width'],
      {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.sharp,
      },
    ),
    '&& > *': {
      flexShrink: 0,
      maxWidth: 'none',
    },
    '&& *': {
      lineHeight: 1,
    },
    '&:empty': {
      display: 'none',
    },
  },
}));
